import { checkIsDefined } from "../../features/Common/modules/DataTypes/utils/nanNullUndef";

export function checkIsBrowser() {
  try {
    return checkIsDefined(window);
  } catch (error) {
    return false;
  }
}
